import { Group, Text } from "@mantine/core";

export const SidebarTitle = ({
  children,
  rightSection,
}: {
  children: React.ReactNode;
  rightSection: React.ReactNode;
}) => {
  return (
    <Group
      justify="space-between"
      pb={4}
      style={{
        borderBottom: "1px solid #ccc",
      }}
    >
      <Text size="sm" fw={600}>
        {children}
      </Text>
      {rightSection}
    </Group>
  );
};
